class CSSVariablesService {
    get(cssVarName: string) {
        return getComputedStyle(document.documentElement)
            .getPropertyValue(cssVarName)
            .trim();
    }
}

export const cSSVariablesService = new CSSVariablesService();